import { Button } from '@sunwebgroup/uds-ui/button'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'

import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import styles from '@/scopes/account/booking-details/pages/components/ManageBookingSection/ManageBookingSection.module.css'
import { RebookingSheetContent } from '@/scopes/account/booking-details/pages/components/ManageBookingSection/RebookingSheetContent'
import { getIsRebookActionShown } from '@/scopes/account/booking-details/pages/selectors'

export function RebookAction() {
  const { formatMessage } = useIntl()
  const { rebookingButtonClicked } = useBookingDetailsActions()
  const isRebookActionShown = useBookingDetailsStore(getIsRebookActionShown)

  if (!isRebookActionShown) {
    return null
  }

  return (
    <Sheet.Root>
      <Sheet.Trigger>
        <Button variant="transparentNeutral" className={styles.actionButton} onClick={rebookingButtonClicked}>
          <Button.Icon glyph="ArrowCirclePath" />
          {formatMessage({ id: 'booking_details_manage_booking_rebook_button_label' })}
        </Button>
      </Sheet.Trigger>
      <Sheet.Body side="right" hasPadding bottomSideInMobile>
        <Sheet.Header
          closeLabel={formatMessage({ id: 'close' })}
          titleLabel={formatMessage({ id: 'booking_details_manage_booking_rebook_button_label' })}
        />
        <Sheet.Content>
          <RebookingSheetContent />
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
